import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import GreenBookingApp from './GreenBookingApp';
import GreenAdminDashboard from './GreenAdminDashboard';
import MembershipPage from './MembershipPage';
import MyBookingsPage from './MyBookingsPage';
import ContactPaymentPage from './ContactPaymentPage';
import ResetPasswordPage from './ResetPasswordPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<GreenBookingApp />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/my-bookings" element={<MyBookingsPage />} />
        <Route path="/contact-payment" element={<ContactPaymentPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/admin" element={<GreenAdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
